<section class="sb-result">
  <div class="sb-kv u-text-center">
    <figure class="sb-kv__img1"><img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330416/c133a00f-a4cb-4b0e-ad98-aa372a3ac7d2.png" alt="あなたにピッタリのタイプは …" class="lazyload"></figure>
    <div class="sb-kv__wrapper">
      <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330419/e360a244-8c29-4890-9581-0fc68673ab7d.png" alt="" class="sb-kv__pc lazyload">
      <p class="sb-kv__text">大学進学</p>
      <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330382/54b17b58-3b2f-42bb-afb5-22f2de3698d5.png" alt="" class="sb-kv__person1 lazyload">
      <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330388/07859e04-c366-4a27-90b7-3e316fe267e3.png" alt="" class="sb-kv__person2 lazyload">
    </div>
  </div>
  <div class="sb-result__section">
    <h1 class="sb-result__title u-text-center">大学進学</h1>
    <figure class="sb-result__img"><img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5401713/f51cb56d-6ec2-4a02-be66-54504047d38b.png" alt="" class="lazyload"></figure>
    <h2 class="sb-result__head u-text-center">説明</h2>
    <p class="sb-result__text">あなたは「学びたい分野が明確」「将来グローバルな舞台で活躍したい」という思いが強いタイプ。長期的な視野でキャリアや人生を捉えています。</p>
    <h2 class="sb-result__head u-text-center">ご提案</h2>
    <p class="sb-result__text">希望する分野の専攻がある大学を探し、必要な英語スコアや出願時期、学費をリサーチしましょう。</p>
  </div>
</section>
